import styled from "@emotion/styled";
import { ContactOption } from "components/UploadCenter/UploadContin/types";
import React from "react";
import CreatableSelect from 'react-select/creatable';


const InputLabel = styled.span<{disabled: boolean}>`
  font-size: 14px;
  color: ${props => (props.disabled ? 'grey' : '#444444')};
`;

interface PropTypes {
    onChangeSelections: (selections: any[]) => void;
    disabled: boolean;
    title: string;
    width?: string;
    contactsList: ContactOption[];
    selectedContactsList: ContactOption[];
    placeholder: string;
}

const EmailAddressMultiselect = (props: PropTypes) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <InputLabel disabled={props.disabled} style={{ marginTop: 15 }}>
        {props.title}
      </InputLabel>
      <div style={{ marginTop: 8, width: props.width ?? '86%' }}>
        <CreatableSelect
          options={props.contactsList}
          onChange={(selections: any[]) => {
            props.onChangeSelections(selections ?? []);
          }}
          value={props.selectedContactsList}
          placeholder={props.placeholder}
          isClearable={true}
          isMulti
          isSearchable
          isDisabled={props.disabled}
        />
      </div>
    </div>
  );
};

export default EmailAddressMultiselect;